import { useEffect, useState } from 'preact/hooks';
import type { ReadonlyObservable } from '../../core';

/** Subscribes a component to an observable from the client core. */
export function useObservable<T>(observable: ReadonlyObservable<T>): T {
  const [value, setValue] = useState(() => observable.get());
  useEffect(() => {
    setValue(observable.get());
    return observable.subscribe(setValue);
  }, [observable]);
  return value;
}
